import { Box, StyledEngineProvider } from "@mui/material";
import { ThemeWrapper } from "@verity/components";
import { CoreMenuItem, CoreSelect } from "@verity/components/core";
import { useEffect, useState } from "react";
import i18n from "../../../../i18n";
import { CustomSettingData } from "../../settings-page";
import styles from "./index.module.css";

const MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;

export type RecordingMaxAgeMonthsLoadData = { recordingMaxAgeMonths: number; };

type Props = {
	loadData: RecordingMaxAgeMonthsLoadData;
	setting: CustomSettingData<number>;
	onSettingChange: (value?: number) => void;
	disabled?: boolean;
	ariaLabelledByTitleId?: string;
};

export const RecordingMaxAgeMonthsInput = ({
	loadData,
	setting,
	onSettingChange,
	disabled,
	ariaLabelledByTitleId,
}: Props) => {
	const [months, setMonths] = useState<number>(setting.value ?? loadData.recordingMaxAgeMonths);

	useEffect(() => {
		onSettingChange(months);
	}, [months, onSettingChange]);

	return (
		<StyledEngineProvider injectFirst>
			<ThemeWrapper>
				<Box className={styles.settingContainer}>
					<span className={styles.settingDescription}>
						{i18n.t("portal.webpages.settingsRootTSX.recordingMaxAgeMonths.description")}
					</span>
					<CoreSelect
						value={String(months)}
						onChange={(e) => setMonths(Number(e.target.value))}
						disabled={disabled}
						inputProps={{ "aria-labelledby": ariaLabelledByTitleId }}
						MenuProps={{
							anchorOrigin: { vertical: "bottom", horizontal: "left" },
							transformOrigin: { vertical: "top", horizontal: "left" },
							slotProps: { paper: { sx: { maxHeight: 200 } } },
						}}
					>
						{MONTHS.map((m) => (
							<CoreMenuItem key={m} value={String(m)}>
								{m}
							</CoreMenuItem>
						))}
					</CoreSelect>
				</Box>
			</ThemeWrapper>
		</StyledEngineProvider>
	);
};
